import React, { useEffect, useRef, useState } from 'react';
import { timeoutInterval } from '../lib/environment-config';
import IdleTimer from '../lib/IdleTimer';
import TimeoutModal from './TimeoutModal';

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function TimeoutModalWrapper() {
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const timer: any = useRef();

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const createIdleTimer = () => {
    timer.current = new IdleTimer({
      timeout: timeoutInterval,
      onTimeout: () => {
        setShowTimeoutModal(true);
      },
    });
    return () => {
      timer.current.cleanUp();
    };
  };

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const storageListener = (e: StorageEvent) => {
    if (e.key === '_modalOpen' || e.key === '_expiredTime') {
      const isModalOpen = localStorage.getItem('_modalOpen');
      if (isModalOpen === 'false') {
        setShowTimeoutModal(false);
      } else if (isModalOpen === 'true') {
        setShowTimeoutModal(true);
      }
    }
  };

  useEffect(() => {
    if (window.location.pathname !== '/') {
      const expiredTime = localStorage.getItem('_expiredTime');
      if (expiredTime) {
        const newExpiredTime = Date.now() + timeoutInterval * 1000;
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        localStorage.setItem('_expiredTime', newExpiredTime);
      }
      createIdleTimer();
      // @ts-expect-error -- This code was written prior to enforcing lint rules
      localStorage.setItem('_modalOpen', false);
      window.addEventListener('storage', storageListener);
      return () => {
        window.removeEventListener('storage', storageListener);
      };
    }
    return () => {
      window.removeEventListener('storage', storageListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [window.location.pathname]);

  useEffect(() => {
    if (showTimeoutModal) {
      // @ts-expect-error -- This code was written prior to enforcing lint rules
      localStorage.setItem('_modalOpen', true);
    } else {
      // @ts-expect-error -- This code was written prior to enforcing lint rules
      localStorage.setItem('_modalOpen', false);
    }
  }, [showTimeoutModal]);

  if (!showTimeoutModal) return null;

  return (
    <TimeoutModal
      closeModal={() => {
        setShowTimeoutModal(false);
      }}
    />
  );
}
